module.exports = __webpack_public_path__ + "img/descBg.97be32e.png";